import { Component } from "react";

/**
 * ErrorBoundary — contains a render crash to its subtree instead of unmounting
 * the whole app (a blank/black page). Used to wrap the interactive chart so a
 * bad data point can never take the entire Forecast Accuracy page down.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ForecastAccuracy chart error (contained):", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="fa-day-loading" role="alert">
            This view hit a snag rendering. Try another day.
          </div>
        )
      );
    }
    return this.props.children;
  }
}
